export enum NotificationsRequestTypes {
  GetAllNotificationsRequest = 'Notifications.GetAll.Request',
  GetAllNotificationsRequestSuccess = 'Notifications.GetAll.Success',
  GetAllNotificationsRequestFailure = 'Notifications.GetAll.Failure',
  MarkAllNotificationsRequest = 'Notifications.MarkAllRead.Request',
  MarkAllNotificationsRequestSuccess = 'Notifications.MarkAllRead.Success',
  MarkAllNotificationsRequestFailure = 'Notifications.MarkAllRead.Failure',
  MarkNotificationRequest = 'Notifications.MarkRead.Request',
  MarkNotificationRequestSuccess = 'Notifications.MarkRead.Success',
  MarkNotificationRequestFailure = 'Notifications.MarkRead.Failure',
}
